import { Application as StimulusApp } from "@hotwired/stimulus"

const Stimulus = StimulusApp.start()

export {
  Stimulus,
}
